import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    linkExactActiveClass: 'active',
    //    base: "/new/",
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/grobbe',
            name: 'grobbe',
            component: () => import('./views/Grobbe.vue'),
            children: [
                {
                    path: '',
                    name: 'boot_reis',
                    component: () => import('./views/Grobbe/BootReis.vue'),
                },
                {
                    path: 'vis',
                    name: 'vis',
                    component: () => import('./views/Grobbe/Vis.vue'),
                }
            ]
        },
        {
            path: '/adam',
            name: 'adam',
            component: () => import('./views/Adam.vue'),
            children: [
                {
                    path: '',
                    name: 'scheepswerven_en_droogdokken',
                    component: () => import('./views/Adam/ScheepswervenEnDroogdokken.vue')
                },
            ]
        },
        {
            path: '/internationaal',
            name: 'internationaal',
            component: () => import('./views/Internationaal.vue'),
            children: [
                {
                    path: '',
                    name: 'new_york',
                    component: () => import('./views/Internationaal/NewYork.vue')
                },
                {
                    path: 'bonaire',
                    name: 'bonaire',
                    component: () => import('./views/Internationaal/Bonaire.vue')
                },
                {
                    path: 'jerevan',
                    name: 'jerevan',
                    component: () => import('./views/Internationaal/Jerevan.vue')
                },
                {
                    path: 'santander',
                    name: 'santander',
                    component: () => import('./views/Internationaal/Santander.vue')
                }
            ]
        },
        {
            path: '/magazine',
            name: 'magazine',
            component: () => import('./views/Magazine.vue'),
            children: [
                {
                    path: '',
                    name: 'magazine-2017',
                    component: () => import('./views/Magazine/2017.vue'),
                },
                {
                    path: '2016',
                    name: 'magazine-2016',
                    component: () => import('./views/Magazine/2016.vue'),
                },
                {
                    path: '2015',
                    name: 'magazine-2015',
                    component: () => import('./views/Magazine/2015.vue'),
                },
                {
                    path: '2014',
                    name: 'magazine-2014',
                    component: () => import('./views/Magazine/2014.vue'),
                },
                {
                    path: '2013',
                    name: 'magazine-2013',
                    component: () => import('./views/Magazine/2013.vue'),
                },
                {
                    path: '2012',
                    name: 'magazine-2012',
                    component: () => import('./views/Magazine/2012.vue'),
                },
                {
                    path: '2011',
                    name: 'magazine-2011',
                    component: () => import('./views/Magazine/2011.vue'),
                },
                {
                    path: '2010',
                    name: 'magazine-2010',
                    component: () => import('./views/Magazine/2010.vue'),
                },
            ]
        },
        {
            path: '/media',
            name: 'media',
            component: () => import('./views/Media.vue')
        },
        {
            path: '/redactie',
            name: 'redactie',
            component: () => import('./views/Redactie.vue')
        },
        {
            path: '/ixat',
            name: 'ixat',
            component: () => import('./views/Ixat.vue')
        },
    ]
})
